import styled from "styled-components";

/* --- Overlay (full screen, dim background) --- */
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  z-index: 6000;

  /* Required for aligning drawer on the right */
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
`;

/* --- Drawer Panel (slides in from right) --- */
export const ModalBox = styled.div`
  width: 420px;
  height: 100vh;
  background: #FCFCFC;
  padding: 24px 32px 32px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: -4px 0 12px rgba(0,0,0,0.25);

  /* Animation */
  transform: translateX(100%);
  transition: transform 0.35s ease-out;

  &.open {
    transform: translateX(0);
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  color: #36424A;
  font-size: 16px;
  font-family: "Noto Sans";
  font-weight: 400;
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  background: transparent;
  border-radius: 50%;
  border: none;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 14px;
    height: 14px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  overflow-y: auto;
`;

/*
 * The form is the Body's ONLY child, so Body's gap never reached the fields and they sat
 * flush against each other (2026-10-01 design review). The 24px between fields lives here.
 */
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  color: #36424A;
  font-size: 14px;
  font-weight: 500;
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  outline: 1px rgba(196,199,200,0.6) solid;
  outline-offset: -1px;
  padding: 8px 16px;
  position: relative;

  .arrow {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 16px;
    pointer-events: none;
  }
`;

export const Select = styled.select`
  appearance: none;
  flex: 1;
  background: transparent;
  border: none;

  font-size: 16px;
  font-weight: 300;
  color: #36424A;
  outline: none;

  &:invalid {
    color: #828A8F;
  }
`;

export const Input = styled.input`
  padding: 8px 16px;
  background: #fff;
  outline: 1px rgba(196,199,200,0.6) solid;
  outline-offset: -1px;
  border: none;

  font-size: 16px;
  color: #36424A;
  font-weight: 300;

  &::placeholder {
    color: #828A8F;
  }
`;

export const Textarea = styled.textarea`
  flex: 1;
  resize: none;

  padding: 16px;
  background: #fff;
  outline: 1px rgba(196,199,200,0.6) solid;
  outline-offset: -1px;
  border: none;

  font-size: 16px;
  color: #36424A;
  font-weight: 300;

  &::placeholder {
    color: #828A8F;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(196,199,200,0.6);
  margin-top: 16px;
`;

export const SubmitRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled.button`
  width: 33.33%;
  padding: 12px 16px;
  border-radius: 30px;

  background: #004D9E;
  color: white;
  font-size: 15px;
  font-weight: 500;
  border: none;

  cursor: pointer;

  &.disabled,
  &:disabled {
    background: #C4C7C8;
    cursor: not-allowed;
  }
`;

export const FieldLabel = styled.label`
  font-family: "Noto Sans";
  font-size: 14px;
  font-weight: 500;
  color: #36424A;
  line-height: 20px;

  display: flex;
  align-items: center;
  gap: 4px;

  .required {
    color: #DC291E;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const CloseSquare = styled.div`
  width: 32px;
  height: 32px;
  position: absolute;
  right: -48px;
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;
